export const achievementData = {
  bio: "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
  achievements: [
    {
      id: 1,
      title: "Senior Software engineer at Cynoia",
      details:
        "Developed and maintained a high-performance collaboration and productivity SAAS platform.",
      date: "Apr, 2025",
      field: "Full Time Job",
    },
    {
      id: 2,
      title: "Team Lead - Software developer at Aroundix",
      details:
        "Led a high-performing development team, coding and fostering collaboration and setting project goals.",
      date: "Nov, 2023",
      field: "Full Time Job",
    },
    {
      id: 3,
      title: "Software Engineer Consultant at HERO Circle",
      details:
        "Reorganized and optimized the structure of a NestJS and React project to improve maintainability and scalability.",
      date: "Aug, 2023",
      field: "Hourly Contractor Job",
    },
    {
      id: 4,
      title: "Software Engineer - Contractor at Front Row Group",
      details:
        "Developed and maintained custom web applications, leveraging full-stack development skills to deliver high-performance solutions.",
      date: "Jul, 2021",
      field: "Hourly Contractor Job",
    },
    {
      id: 5,
      title: "Software Engineer - Full Stack web developer at Edonec",
      details:
        "Worked with react, react native and node.js and many other tools to create and maintain multiple web/mobile projects.",
      date: "June, 2020",
      field: "Full Time Job",
    },
    {
      id: 6,
      title: "Full Stack web developer at Germanetti",
      details:
        "Developement of a managment application using angular and spring.",
      date: "Apr, 2020",
      field: "Internship",
    },
    {
      id: 7,
      title: "Automation engineer at Poulina group Holding",
      details:
        "Using Siemens controllers to implement an Automated Guided Vehicles (AGV) system to automate and facilitate the product storage using VB and mssql.",
      date: "Feb, 2019",
      field: "Internship",
    },
    {
      id: 8,
      title: "Embedded system engineer at Kollab Agency",
      details:
        "Designing and modeling of a self flying drone using raspberry as an advertising floating screen.",
      date: "Mar, 2018",
      field: "Internship",
    },
  ],
};
